import { useResolvedCompanyCtx } from '@contexts/ResolvedCompanyContext/ResolvedCompanyProvider';
import * as React from 'react';
import { ProductDetailMachineProvider as SharedProductDetailMachineProvider, useProductDetailMachine } from '~shared/segments/ProductDetail';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Wrapper for providing machine service that controls product detail loading, state & caching.
 * ! This machine should stay rendered throughout the MenuScreen lifecycle, otherwise the cache will be lost.
 */
export var ProductDetailMachineProvider = function ProductDetailMachineProvider(_ref) {
  var _sector$warePriceType;

  var children = _ref.children;

  var _useResolvedCompanyCt = useResolvedCompanyCtx(),
      resolvedBranch = _useResolvedCompanyCt.resolvedBranch,
      sector = _useResolvedCompanyCt.sector;

  return /*#__PURE__*/_jsx(SharedProductDetailMachineProvider, {
    branchId: resolvedBranch.id,
    warePriceType: sector === null || sector === void 0 ? void 0 : (_sector$warePriceType = sector.warePriceType) === null || _sector$warePriceType === void 0 ? void 0 : _sector$warePriceType["enum"],
    children: children
  });
};
export { useProductDetailMachine };